<template>
  <div class="mainLayout">

    <div id="mapLayout" class="mapLayout">
      <TheMap :geoJSONCollection="filteredFeatures" />
    </div>

    <TheMetadataUI style="position: absolute; top: 64px;"
                  :filterPropertyKeys="filterPropertyKeys"
                  :filterMap="filterMap"
                  @filterChange="catchFilterChange"
    />

  </div>

  <div class="legend">
    <ul>
      <li><span class="legend-plants"></span> Plants</li>
      <li><span class="legend-protists"></span> Protists</li>
      <li><span class="legend-vertebrates"></span> Vertebrates</li>
      <li><span class="legend-invertebrates"></span> Invertebrates</li>
      <li><span class="legend-fungi"></span> Fungi</li>
    </ul>
  </div>
</template>

<script lang="ts">
import TheMap from '../components/TheMap.vue'
import TheMetadataUI from "@/components/TheMetadataUI.vue";
import {useMetadataStore} from "@/stores/metadataStore";
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    TheMap,
    TheMetadataUI,
  },
  computed: {
    filterMap() {
      const mStore = useMetadataStore();
      return mStore.filterMap;
    },
    filterPropertyKeys() {
      const mStore = useMetadataStore();
      return mStore.filterPropertyKeys;
    },
    filteredFeatures() {
      const mStore = useMetadataStore();
      return mStore.filteredFeatures;
    },
  },
  methods: {
    catchFilterChange(filterItem: ActiveFilterItem) {
      const mStore = useMetadataStore();
      mStore.changeFilter(filterItem);

      // console.log(mStore.filteredMetadata.length);
    }
  },
})

</script>

<style>
  .mainLayout {
/*    display: grid;
    grid-template-rows: 3fr 1fr;*/
    width: 100%;
    height: 100%;
  }

  .mapLayout {
    display: grid;
    width: 100%;
    height: 100%;
    background-color: beige;
  }
  .legend {
    position: absolute;
    bottom: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.8);
    padding: 10px;
    border-radius: 5px;
  }

  .legend h3 {
    margin-top: 0;
  }
  .legend ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .legend ul li {
    margin-bottom: 5px;
    font-size: 13px;
  }
  .legend span {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    border: 1px solid #333;
    border-radius: 50%;
  }
  .legend-plants { background: #537A29; } /* Brighter green */
  .legend-protists { background: #219EBC; } /* This blue is generally okay */
  .legend-vertebrates { background: #FFBF1F; } /* Distinct golden yellow */
  .legend-invertebrates { background: #C1121F; } /* Darker red */
  .legend-fungi { background: #023047; } /* Indigo to avoid confusion with dark blues/blacks */

</style>
